module.exports = __webpack_public_path__ + "assets/fonts/Roboto-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/Roboto-Regular.woff
// module id = 689
// module chunks = 0